<!--
  - 首页组件
-->

<template>
  <div class="bl-index">
    <!-- 首页banner -->
    <widgets_banner/>

    <div class="bl-content">
      <div class="bl-main">
        <!-- 主分类 -->
        <widgets_navbar/>

        <!-- 内容 -->
        <widgets_main/>
      </div>
    </div>

  </div>
</template>

<script>
  import widgets_banner from './widgets/banner'
  import widgets_navbar from './widgets/navbar'
  import widgets_main from './widgets/main'


  export default {
    name: 'bl-index',
    data(){
      return {};
    },
    beforeRouteLeave(to, from, next){
      window.cancelAnimationFrame(window.animation_id);
      next();
    },
    methods: {},
    components: {
      widgets_banner,
      widgets_navbar,
      widgets_main,
    },
    created(){
    }
  }
</script>

<style scoped lang="less">
  .bl-index {
  }

  .bl-navbar {
    margin-top: 10px;
  }
</style>
